<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 6">
    <path
      d="M6.452.286 3.187 3.84l-1.616-1.6C.75 1.427-.559 2.656.26 3.467l2.303 2.281c.325.322.991.35 1.311 0l3.89-4.236C8.536.67 7.23-.563 6.451.286Z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
